module.exports = __webpack_public_path__ + "media/images/ups-f617b50fde0f25aaed83d5f4ea00761d.png";